// A PÉNZÜGY védett jogai — EGY helyen, a BFF jog-kapui és a web fül-kapui is innen dolgoznak.
//
// A „Bevétel/kiadás" jog KÉTFELÉ vált (user-döntés): a Bevétel és a Kiadás külön, névre szóló védett jog. Akinek
// csak az egyik van, az csak annak a fülét és elemzését látja; az Áttekintés mindkettőt kéri.
//
// A lista „bármelyik" jelentésű: a BFF `@RequirePermissions` is így értelmezi a felsorolást.
export const FINANCE_PERMISSIONS = {
    /** Bevétel: a Bevételek fül, a Bevétel-elemzés és a kezdőlap MRR-kártyája. */
    revenueView: ['finance.revenue.view'],
    /** Kiadás: a Kiadások fül, a Kiadás-elemzés és a kiadás-találatok a keresőben. */
    expensesView: ['finance.expenses.view'],
    expensesManage: ['finance.expenses.manage'],
    expensesDelete: ['finance.expenses.delete'],
};
/** Van-e a felsorolt jogok BÁRMELYIKE (a `can` a hívó jog-ellenőrzője). */
export function hasAnyPermission(keys, can) {
    return keys.some((k) => can(k));
}
//# sourceMappingURL=finance-permissions.js.map